<template>
  <g>
    <path
      d="M9.5 0.5C4.5204 0.5 0.5 4.5204 0.5 9.5C0.5 14.4796 4.5204 18.5 9.5 18.5C14.4796 18.5 18.5 14.4796 18.5 9.5C18.5 4.5204 14.4796 0.5 9.5 0.5ZM14.9796 14.9796C13.5194 16.4398 11.5796 17.2398 9.5 17.2398C7.4398 17.2398 5.4796 16.4398 4.0204 14.9796C2.56024 13.5194 1.7602 11.5796 1.7602 9.5C1.7602 7.4398 2.5602 5.4796 4.0204 4.0204C5.48056 2.56024 7.4204 1.7602 9.5 1.7602C11.5602 1.7602 13.5204 2.5602 14.9796 4.0204C16.4398 5.48056 17.2398 7.4204 17.2398 9.5C17.2398 11.5602 16.4398 13.5204 14.9796 14.9796Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.39786 7.89097C5.39786 7.89097 4.04457 6.7744 5.38945 5.42952C6.73434 4.08463 7.85082 5.43801 7.85082 5.43801L13.426 11.0131L13.4472 11.0343C13.4809 11.068 13.5014 11.1126 13.5052 11.1601L13.5088 11.2066L13.6903 13.5153C13.6999 13.6378 13.5978 13.74 13.4752 13.7304L11.1665 13.5489L11.12 13.5452C11.0725 13.5415 11.0279 13.521 10.9943 13.4873L10.9731 13.4661L5.39786 7.89097ZM6.86281 8.15276L8.11277 6.90281L12.7205 11.5106L11.4706 12.7605L6.86281 8.15276ZM5.99709 6.22623C5.7042 6.51912 5.7042 6.99399 5.99709 7.28689L6.22871 7.5185L7.47866 6.26855L7.24705 6.03693C6.95416 5.74404 6.47928 5.74404 6.18639 6.03693L5.99709 6.22623Z"
      fill="white"
    />
  </g>
</template>
<script>
export default {
  name: 'icon-circle-edit',
}
</script>
